import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_ADMISSION_SOURCE_LIST = "GET_ADMISSION_SOURCE_LIST";

export const service = async () => {
  const options: object = {
    url: "/api/AdmissionSource/GetAdmissionSource",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_ADMISSION_SOURCE_LIST, service, mock);
